import { render } from "./CustomerUsersPage.vue?vue&type=template&id=4a9e64ca"
import script from "./CustomerUsersPage.vue?vue&type=script&lang=js"
export * from "./CustomerUsersPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/saas-stack/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__